import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { GoChevronDown, GoX } from 'react-icons/go';
import { HiOutlineFilter } from 'react-icons/hi';

import { Button } from 'components/elements/button';
import Maybe from 'components/elements/maybe';
import { useFilterBoxItems } from '../../hooks/useFIlterBoxItems';
import FilterBoxItemDropDown from './FilterBoxItemDropDown';
import { GenerateTitle } from './GenerateTitle';
import RenderFields from './RenderFields';

import styles from 'components/modules/plp/styles/filterbox.module.scss';
// import LocationField from './locationField';

import dynamic from 'next/dynamic';
import { PlpTypes } from '../../../../../../lib/apis/services/PlpListing';
import { useGlobalStore } from '../../../../../../lib/DataStore';
import { usePlpStore } from '../../../DataStore';
import { toast } from 'react-toastify';

const LocationSearchInput = dynamic(import('components/elements/searchBox/locationSearchInput'), { ssr: false });

interface Props {
  onLocationSelected: (
    _location: (Partial<PlpTypes.DescribedLocationV2> | PlpTypes.AreaLocation)[],
  ) => void;
  name: string;
  city: Partial<PlpTypes.DescribedLocationV2>,
  regions: Partial<PlpTypes.DescribedLocationV2>[]
}

function FilterBoxItems() {
  const {
    checkActive,
    orderedField,
    semanticFilterBox,
    openMenu,
    allFilter,
    setOpenMenu,
    useDevice,
    clearField,
    restMethods,
    t,
  } = useFilterBoxItems()

  const { userDevice } = useGlobalStore()
  const { describeLocations, setDescribeLocation, setData, filterData } = usePlpStore();
  let city: Partial<PlpTypes.DescribedLocationV2>[] = describeLocations ? describeLocations.filter(item => item.type === 'city') : [],
    regions: Partial<PlpTypes.DescribedLocationV2>[] = describeLocations ? describeLocations.filter(item => item.type === 'region') : [];



  const changeLocation = (data: Partial<PlpTypes.DescribedLocationV2>[]) => {
    {/* eslint-disable-next-line no-prototype-builtins */ }
    const changeCity = data.filter(item => item.hasOwnProperty('haveRegion')).map(item => ({ ...item, type: "city" }));
    {/* eslint-disable-next-line no-prototype-builtins */ }
    const changeRegions = data.filter(item => !item.hasOwnProperty('haveRegion')).map(item => ({ ...item, type: "region" }));
    let finalLocation: Partial<PlpTypes.DescribedLocationV2>[] | [] = [];
    if (changeCity?.length) {
      finalLocation = changeCity;
    }
    if (changeRegions?.length) {
      finalLocation = [...finalLocation, ...changeRegions];
    }
    if(changeCity?.length > 0) {
      filterData.city = changeCity[0].id;
      filterData.region_IN = changeRegions.map(item =>
        typeof item === 'number' ? item : (item && item.id !== undefined) ? +item.id : '',
      ).join(',');
      setData(filterData, 'FilterBoxItem.tsx');
      setDescribeLocation(finalLocation);
    }
    else {
      toast.error('شهری انتخاب نشده است');
    }
  }

  const clearAll = () => {
    semanticFilterBox.forEach((item) => {
      switch (item.type) {
        case 'INTEGER':
          restMethods.setValue(item.fieldName, null, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
          restMethods.setValue(`${item.fieldName}Exact`, false, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
          break;
        case 'RANGE':
          restMethods.setValue(
            item.fieldName,
            {
              min: null,
              max: null,
            },
            {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            }
          );
          break;
        default:
          if (
            !['propertyType_IN', 'listingType', 'landuseType'].includes(
              item.fieldName
            )
          ) {
            restMethods.setValue(item.fieldName, [], {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
          }
          break;
      }
    });

    // restMethods.trigger();
  };

  //allFilter == ref to dropdown
  //semanticFilterBox == list of all filtered define in semanticFilterBox.ts
  //semanticFilterBox.ts == any change in keys and value of filter change in this file
  //orderedField == list of all filter sorted by active and inactive filed


  return (
    <div className="relative min-h-[42px]" id="filter-box">
      <div
        className={clsx('flex flex-row pb-2 overflow-x-auto', [
          styles['filter-box-scroll'],
        ])}
      >
        <div className="flex space-x-4 rtl:space-x-reverse">
          {/*این قسمت همه فیلترهای به صورت کلی وجود دارد*/}
          <FilterBoxItemDropDown
            ref={allFilter}
            active
            open={openMenu}
            onClose={() => {
              setOpenMenu(false);
            }}
            clear={() => clearAll()}
            title={
              <>
                <HiOutlineFilter />
                <span>{t('allFilters')}</span>
              </>
            }
          >
            <div className='flex flex-col p-4 space-y-4 md:w-full'>
              <Maybe condition={userDevice === 'MOBILE'}>
                <div className='flex flex-col space-y-2' id='mobileFilterbox-location'>
                  <span className='text-lg font-bold text-grey-700'>محله</span>
                  {/**/}
                  {/*<LocationField name="location" />*/}
                  <LocationSearchInput onLocationSelected={changeLocation} city={city[0]} regions={regions} name={'filterBox'} />
                </div>
                <hr />
              </Maybe>
              {semanticFilterBox.map((item, index) => (
                <Fragment key={`${item.fieldName}-all`}>
                  <div
                    className="flex flex-col space-y-2"
                    id={`mobileFilterbox-${item.name}`}
                  >
                    <span className="text-lg font-bold text-grey-700">
                      {item.title}
                    </span>
                    <RenderFields item={item} />
                  </div>
                  {index !== semanticFilterBox.length - 1 && <hr />}
                </Fragment>
              ))}
            </div>
            <div className="sticky bottom-0 justify-end hidden px-4 pb-4 md:flex">
              <span>
                <Button
                  variant="light"
                  onClick={() => {
                    clearAll();
                  }}
                >
                  {t('global.clear', true)}
                </Button>
              </span>
            </div>
          </FilterBoxItemDropDown>

          {orderedField.map((item) => (
            <FilterBoxItemDropDown
              key={item.fieldName}
              active={checkActive(item)}
              alwaysShowPanel={useDevice === 'DESKTOP'}
              titleText={item.title}
              onClick={() => {
                if (useDevice !== 'DESKTOP') {
                  if (allFilter.current) {
                    allFilter.current.openHandler(item.name);
                  }
                }
              }}
              title={
                <>
                  <span>
                    <GenerateTitle item={item} isActive={checkActive(item)} />
                  </span>
                  {item.fieldName !== 'propertyType_IN' &&
                    item.fieldName !== 'listingType' &&
                    item.fieldName !== 'landuseType' ? (
                    checkActive(item) ? (
                      <span
                        className="p-1 hover:text-primary-900"
                        onClick={(e) => {
                          e.stopPropagation();
                          clearField(item);
                        }}
                      >
                        <GoX className="font-bold" />
                      </span>
                    ) : (
                      <GoChevronDown className="font-bold" />
                    )
                  ) : (
                    <GoChevronDown className="font-bold" />
                  )}
                </>
              }
            >
              <div className="flex flex-col w-full p-6 pt-2 space-y-4 min-w-[15rem]">
                {/*لیست ایتم های فیلتر ها*/}
                <RenderFields item={item} />
              </div>
              {/*باتم پاک کردن همه فیلترها که در نوع آگهی و نوع کاربری و نوع ملک وجود ندارد.*/}
              <Maybe
                condition={
                  // نوع کاربری
                  item.fieldName !== 'propertyType_IN' &&
                  // نوع آگهی
                  item.fieldName !== 'listingType' &&
                  // نوع ملک
                  item.fieldName !== 'landuseType'
                }
              >
                <div className="sticky bottom-0 flex justify-end px-4 pb-4 right-full w-fit">
                  <span>
                    <Button
                      variant="light"
                      onClick={() => {
                        clearField(item);
                      }}
                    >
                      {t('global.clear', true)}
                    </Button>
                  </span>
                </div>
              </Maybe>
            </FilterBoxItemDropDown>
          ))}
        </div>
      </div>
    </div>
  );
}

export default observer(FilterBoxItems);
